import { render, staticRenderFns } from "./AdvisorSideBar.vue?vue&type=template&id=b0ff351a&"
import script from "./AdvisorSideBar.vue?vue&type=script&lang=js&"
export * from "./AdvisorSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports